import { render, staticRenderFns } from "./CourseFeedback.vue?vue&type=template&id=72025ac5&scoped=true"
import script from "./CourseFeedback.vue?vue&type=script&lang=js"
export * from "./CourseFeedback.vue?vue&type=script&lang=js"
import style0 from "./CourseFeedback.vue?vue&type=style&index=0&id=72025ac5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72025ac5",
  null
  
)

export default component.exports